import { MINUTE } from '../../../constants/constants';

export const customTimezoneMap: { id: number; offset: number }[] = [
  { id: 23, offset: 720 * MINUTE }, // 12 hours in the past
  { id: 24, offset: 705 * MINUTE },
  { id: 25, offset: 690 * MINUTE },
  { id: 26, offset: 675 * MINUTE },
  { id: 27, offset: 660 * MINUTE },
  { id: 28, offset: 645 * MINUTE },
  { id: 29, offset: 630 * MINUTE },
  { id: 30, offset: 615 * MINUTE },
  { id: 31, offset: 600 * MINUTE },
  { id: 32, offset: 585 * MINUTE },
  { id: 33, offset: 570 * MINUTE },
  { id: 34, offset: 555 * MINUTE },
  { id: 35, offset: 540 * MINUTE },
  { id: 36, offset: 525 * MINUTE },
  { id: 37, offset: 510 * MINUTE },
  { id: 38, offset: 495 * MINUTE },
  { id: 39, offset: 480 * MINUTE },
  { id: 40, offset: 465 * MINUTE },
  { id: 41, offset: 450 * MINUTE },
  { id: 42, offset: 435 * MINUTE },
  { id: 43, offset: 420 * MINUTE },
  { id: 44, offset: 405 * MINUTE },
  { id: 45, offset: 390 * MINUTE },
  { id: 46, offset: 375 * MINUTE },
  { id: 47, offset: 360 * MINUTE },
  { id: 48, offset: 345 * MINUTE },
  { id: 49, offset: 330 * MINUTE },
  { id: 50, offset: 315 * MINUTE },
  { id: 51, offset: 300 * MINUTE }, // 6 hours in the past
  { id: 53, offset: 285 * MINUTE },
  { id: 54, offset: 270 * MINUTE },
  { id: 52, offset: 255 * MINUTE },
  { id: 55, offset: 240 * MINUTE },
  { id: 56, offset: 225 * MINUTE },
  { id: 57, offset: 210 * MINUTE },
  { id: 58, offset: 195 * MINUTE },
  { id: 59, offset: 180 * MINUTE },
  { id: 60, offset: 165 * MINUTE },
  { id: 61, offset: 150 * MINUTE },
  { id: 62, offset: 135 * MINUTE },
  { id: 63, offset: 120 * MINUTE },
  { id: 64, offset: 105 * MINUTE },
  { id: 65, offset: 90 * MINUTE },
  { id: 66, offset: 75 * MINUTE },
  { id: 67, offset: 60 * MINUTE },
  { id: 68, offset: 45 * MINUTE },
  { id: 69, offset: 30 * MINUTE },
  { id: 70, offset: 15 * MINUTE },
  { id: 71, offset: 0 }, // now
  { id: 72, offset: -15 * MINUTE },
  { id: 73, offset: -30 * MINUTE },
  { id: 74, offset: -45 * MINUTE },
  { id: 75, offset: -60 * MINUTE },
  { id: 76, offset: -75 * MINUTE },
  { id: 77, offset: -90 * MINUTE },
  { id: 78, offset: -105 * MINUTE },
  { id: 79, offset: -120 * MINUTE },
  { id: 80, offset: -135 * MINUTE },
  { id: 81, offset: -150 * MINUTE },
  { id: 82, offset: -165 * MINUTE },
  { id: 83, offset: -180 * MINUTE },
  { id: 84, offset: -195 * MINUTE },
  { id: 85, offset: -210 * MINUTE },
  { id: 86, offset: -225 * MINUTE },
  { id: 87, offset: -240 * MINUTE },
  { id: 88, offset: -255 * MINUTE },
  { id: 89, offset: -270 * MINUTE },
  { id: 90, offset: -285 * MINUTE },
  { id: 91, offset: -300 * MINUTE }, // 6 hours in the future
  { id: 92, offset: -315 * MINUTE },
  { id: 93, offset: -330 * MINUTE },
  { id: 94, offset: -345 * MINUTE },
  { id: 95, offset: -360 * MINUTE },
  { id: 96, offset: -375 * MINUTE },
  { id: 97, offset: -390 * MINUTE },
  { id: 98, offset: -405 * MINUTE },
  { id: 99, offset: -420 * MINUTE },
  { id: 100, offset: -435 * MINUTE },
  { id: 101, offset: -450 * MINUTE },
  { id: 102, offset: -465 * MINUTE },
  { id: 103, offset: -480 * MINUTE },
  { id: 104, offset: -495 * MINUTE },
  { id: 105, offset: -510 * MINUTE },
  { id: 106, offset: -525 * MINUTE },
  { id: 107, offset: -540 * MINUTE },
  { id: 108, offset: -555 * MINUTE },
  { id: 109, offset: -570 * MINUTE },
  { id: 110, offset: -585 * MINUTE },
  { id: 111, offset: -600 * MINUTE }, // 10 hours in the future
  { id: 112, offset: -615 * MINUTE },
  { id: 113, offset: -630 * MINUTE },
  { id: 114, offset: -645 * MINUTE },
  { id: 115, offset: -660 * MINUTE },
  { id: 116, offset: -675 * MINUTE },
  { id: 117, offset: -690 * MINUTE },
  { id: 118, offset: -705 * MINUTE },
  { id: 119, offset: -720 * MINUTE },
  { id: 120, offset: -735 * MINUTE },
  { id: 121, offset: -750 * MINUTE },
  { id: 122, offset: -765 * MINUTE },
  { id: 123, offset: -780 * MINUTE },
  { id: 124, offset: -795 * MINUTE },
  { id: 125, offset: -810 * MINUTE },
  { id: 126, offset: -825 * MINUTE },
  { id: 127, offset: -840 * MINUTE } // 14 hours in the future
];
